module.exports = __webpack_public_path__ + "img/stegi-radio-logo.40a6a474.svg";